import { getLang } from './i18n';

const locale = (): string => (getLang() === 'pt' ? 'pt-BR' : 'es-CL');

/** Inteiro com separador de milhar no idioma atual. */
export const fmt = (n: number): string => new Intl.NumberFormat(locale()).format(n);

/** Pesos chilenos: sem centavos, com `$`. */
export const money = (v: number | null | undefined): string =>
  '$' + new Intl.NumberFormat(locale()).format(Math.round(v || 0));

export const dateTime = (ts: number): string =>
  new Date(ts).toLocaleString(locale(), { dateStyle: 'short', timeStyle: 'short' });
